import React from 'react'

export default function Footer() {
  return (
    <div>
        <h1>Footer Content</h1>
    </div>
  )
}
